import { Component, OnInit } from '@angular/core';
import { RequestUserStatusActionSettingRemoteDto } from 'src/generated/signalR/request-user-status-action-setting-remote-dto';
import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';
import { map, tap } from 'rxjs/operators';
import _ from 'lodash';
import { UserActionSettingChanged } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.actions';
import { ActionSpecificSettingsComponent } from '../action-specific-settings-component';
import { UserStatusInfoRemoteDto } from 'src/generated/signalR/user-status-info-remote-dto';
import { SamwinUserStatusSelectors } from 'src/app/store/samwin/samwin-user-status/samwin-user-status.selectors';
import { ToolbarSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.state';

@Component({
   selector: 'samweb-request-user-status-action-settings',
   templateUrl: './request-user-status-action-settings.component.html',
   styleUrls: ['./request-user-status-action-settings.component.scss'],
})
export class RequestUserStatusActionSettingsComponent extends ActionSpecificSettingsComponent implements OnInit {
   public actionSetting$: Observable<RequestUserStatusActionSettingRemoteDto>;

   @Select(SamwinUserStatusSelectors.getAllSelectableStatusInfos)
   public samwinUserStates$: Observable<UserStatusInfoRemoteDto[]>;

   constructor(private store: Store) {
      super();
   }

   ngOnInit(): void {
      this.actionSetting$ = this.store.select(ToolbarSettingsState.getActionSettingFn).pipe(
         map((fn) => fn(this.brickInstanceId, this.toolbarId, this.actionId)),
         map((x) => x as RequestUserStatusActionSettingRemoteDto),
         map((x) => _.cloneDeep(x))
      );
   }

   requestUserStatusChanged(settings: RequestUserStatusActionSettingRemoteDto, value: number) {
      settings.requestUserStatus = value;
      this.store.dispatch(new UserActionSettingChanged(this.brickInstanceId, this.toolbarId, this.actionId, settings));
   }
}
